module.exports = __webpack_public_path__ + "img/finland-blood-diseases-male.60ccc7d3.png";